import { useContext, useEffect, useState } from "react";
import {
  BreadTransaction,
  P,
  Predicate,
  FirestoreDocTag,
} from "breadcommon";
import { TransactionColumn } from "./TransactionColumn";
import { TransactionsNavContext } from "./TransactionsScreen";
import { buildClasses } from "../utils/buildClasses";
import { RyeDropDownMultiSelect } from "../rye/RyeDropDownMultiSelect";
import { TagsContext } from "../firebaseio/TagsContext";
import { TransactionColumnFilterProps } from "./DefaultTransactionColumnHeader";
import { TagDot } from "../tags_screen/TagDot";

export function TransactionColumnFilterTags({
  isOpen,
  onClose,
  hasActiveFilter,
}: TransactionColumnFilterProps): JSX.Element | null {
  const [transactionsNav, setTransactionsNav] = useContext(
    TransactionsNavContext,
  );
  const tags = useContext(TagsContext);
  const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);

  useEffect(() => {
    if (!hasActiveFilter) {
      setSelectedTagIds([]);
    }
  }, [hasActiveFilter]);

  function createTagsPredicate(tagIds: string[]): Predicate | null {
    if (tagIds.length === 0) {
      return null;
    }
    const field = P.Field<BreadTransaction, "tagIds">("tagIds");
    const predicates = tagIds.map((id) =>
      P.ListContains(field, P.Literal<string>(id)),
    );
    return P.Any(...predicates);
  }

  function applyFilter(tagIds: string[]) {
    const currentSettings =
      transactionsNav.columnSettings[TransactionColumn.TAGS];
    setTransactionsNav((prevState) => ({
      ...prevState,
      columnSettings: {
        ...transactionsNav.columnSettings,
        [TransactionColumn.TAGS]: {
          ...currentSettings,
          predicate: createTagsPredicate(tagIds),
        },
      },
    }));
  }

  function handleSelectionChange(tagIds: string[]) {
    setSelectedTagIds(tagIds);
    applyFilter(tagIds);
  }

  if (!isOpen) {
    return null;
  }

  const tagEntries = Array.from(tags.values())
    .sort(
      (a: FirestoreDocTag, b: FirestoreDocTag) =>
        a.order_position - b.order_position,
    )
    .map((tag: FirestoreDocTag) => ({
      id: tag.id,
      text: tag.name,
      icon: <TagDot colorId={tag.color} size="sm" />,
    }));

  return (
    <div className={buildClasses("flex", "flex-col", "gap-2")} tabIndex={-1}>
      <RyeDropDownMultiSelect
        selectedEntryIds={selectedTagIds}
        entries={tagEntries}
        onSelectionChange={handleSelectionChange}
        onEsc={onClose}
        searchable
        size="md"
        width="lg"
        variant="outlined"
      />
    </div>
  );
}
